import "emoji-mart/css/emoji-mart.css";

import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { DateProvider } from "../DateContext/DateContext";
import Paywall from "../Paywall/Paywall";
import { usePaywallStateDispatch } from "../Paywall/PaywallContext";
import TrialEndModal from "../TrialEndModal/TrialEndModal";
import DiscordMembersView from "./DiscordMembersView.tsx";
import { DiscordRolesProvider } from "./DiscordRolesContext.tsx";
import SlackMembers from "./SlackMembers";

const Members = () => {
  const platform = localStorage.getItem("platform");
  const { loadingPlanTier, userPlanTier } = usePaywallStateDispatch();

  useEffect(() => {
    document.title = "Members | Dots";
  }, []);

  if (platform === "slack")
    return (
      <div>
        <SlackMembers />
      </div>
    );

  return (
    <div>
      <DateProvider>
        <DiscordRolesProvider>
          <Paywall
            free={<TrialEndModal imagePreview="members-preview" />}
            pro={<DiscordMembersView />}
            business={<DiscordMembersView />}
            tier={userPlanTier}
            loading={loadingPlanTier}
          />
        </DiscordRolesProvider>
      </DateProvider>
    </div>
  );
};

export default Members;
